import {
  BLACK_COLOR,
  BLUE_COLOR,
  BLUE_DARK_COLOR,
  BROWN_COLOR,
  BROWN_DARK_COLOR,
  GREY_COLOR,
  GREY_DARK_COLOR,
  JADE_COLOR,
  JADE_DARK_COLOR,
  MAGENTA_COLOR,
  MAGENTA_DARK_COLOR,
  NAVY_COLOR,
  NAVY_DARK_COLOR,
  PINK_COLOR,
  PINK_DARK_COLOR,
  PUMPKIN_COLOR,
  PUMPKIN_DARK_COLOR,
  PURPLE_COLOR,
  PURPLE_DARK_COLOR,
  RED_COLOR,
  RED_DARK_COLOR,
  TURQUOISE_COLOR,
  TURQUOISE_DARK_COLOR
} from '../../CombinedGenerator/components/Inputs/constants'
import { FlowcodeColorOptionType } from '@app/common/src/types/createFlowcode.types'
import {
  LandingPageDestination,
  LandingPageDestinationType
} from '@dtx-company/inter-app/src/types/flowcode'

export const SORTED_SIMPLIFIED_DESKTOP_SCAN_DESTINATIONS_V1: LandingPageDestinationType[] = [
  {
    label: 'Website',
    id: LandingPageDestination.URL,
    src: '',
    alt: 'website',
    placeholder: 'Enter or paste a URL',
    alfredIcon: true
  },
  {
    label: 'File',
    id: LandingPageDestination.FILE,
    src: '',
    alt: 'file',
    placeholder: 'my_file (20mb limit)',
    alfredIcon: true
  },
  {
    label: 'Image',
    id: LandingPageDestination.IMAGE,
    src: '',
    alt: 'Image',
    placeholder: 'myfile.png',
    alfredIcon: true
  },
  {
    label: 'SMS',
    id: LandingPageDestination.SMS,
    src: '',
    alt: 'sms',
    placeholder: '555-555-5555',
    alfredIcon: true
  },
  {
    label: 'Email',
    id: LandingPageDestination.EMAIL,
    src: '',
    alt: 'email',
    placeholder: 'myemail@email.com',
    alfredIcon: true
  },
  {
    label: 'Instagram',
    id: LandingPageDestination.INSTAGRAM,
    src: '',
    alt: 'instagram',
    placeholder: 'handle',
    alfredIcon: true
  },
  {
    label: 'Facebook',
    id: LandingPageDestination.FACEBOOK,
    src: '',
    alt: 'facebook',
    placeholder: 'facebook.com/GetFlowcode',
    alfredIcon: true
  },
  {
    label: 'YouTube',
    id: LandingPageDestination.YOUTUBE,
    src: '',
    alt: 'facebook',
    placeholder: 'www.youtube.com/c/',
    alfredIcon: true
  },
  {
    label: 'Google doc',
    id: LandingPageDestination.GOOGLE_DOC,
    src: '',
    alt: 'google doc',
    placeholder: 'https://docs.google.com/document',
    alfredIcon: true
  }
]

export const LOGGED_OUT_GENERATOR_COLORS: FlowcodeColorOptionType[] = [
  BLACK_COLOR,
  GREY_DARK_COLOR,
  GREY_COLOR,
  BROWN_DARK_COLOR,
  BROWN_COLOR,
  PUMPKIN_DARK_COLOR,
  PUMPKIN_COLOR,
  RED_DARK_COLOR,
  RED_COLOR,
  MAGENTA_DARK_COLOR,
  MAGENTA_COLOR,
  PINK_DARK_COLOR,
  PINK_COLOR,
  PURPLE_DARK_COLOR,
  PURPLE_COLOR,
  NAVY_DARK_COLOR,
  NAVY_COLOR,
  BLUE_DARK_COLOR,
  BLUE_COLOR,
  TURQUOISE_DARK_COLOR,
  TURQUOISE_COLOR,
  JADE_DARK_COLOR,
  JADE_COLOR
]
